// extracted by mini-css-extract-plugin
var _1 = "CalendarGridDayPopoverRow-moduleCalendarGridDayPopoverRow__LRIND";
var _2 = "CalendarGridDayPopoverRow-modulerow__spLqs";
var _3 = "CalendarGridDayPopoverRow-modulestatus__K9_Kj";
var _4 = "CalendarGridDayPopoverRow-moduletag__J3F_f";
var _5 = "CalendarGridDayPopoverRow-moduletime__AB2fI";
export { _1 as "CalendarGridDayPopoverRow", _2 as "row", _3 as "status", _4 as "tag", _5 as "time" }
